module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.$store.getters.type == 1) ? _c('div', [_c('el-row', {
    staticClass: "mb20"
  }, [_c('span', {
    staticClass: "f16 bold pr10"
  }, [_vm._v("数据看板")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.viewScreen
    }
  }, [_vm._v("点击查看数据墙→")]), _vm._v(" "), _c('span', {
    staticClass: "pl10"
  }, [_vm._v("为学校提供可视化大屏展示本校实时数据，可应用于学校大屏看板墙")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "fr",
    attrs: {
      "size": "mini",
      "type": "month",
      "placeholder": "选择月份"
    },
    on: {
      "change": function($event) {
        return _vm.getReportSummary()
      }
    },
    model: {
      value: (_vm.month),
      callback: function($$v) {
        _vm.month = $$v
      },
      expression: "month"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mb20 row-1 data",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "has-bg",
    attrs: {
      "span": 6
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('p', {
    staticClass: "c9 f12"
  }, [_vm._v("下单数")]), _vm._v(" "), _c('p', {
    staticClass: "f24",
    staticStyle: {
      "padding-top": "3px"
    }
  }, [_vm._v(_vm._s(_vm.summary.orderSum || 0))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('i', {
    staticClass: "icon icon-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "c9 f12"
  }, [_vm._v("送达率")]), _vm._v(" "), _c('p', {
    staticClass: "bold f16",
    staticStyle: {
      "padding-bottom": "4px"
    }
  }, [_vm._v(_vm._s(_vm.summary.deliveryRate || 0) + "%")]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "percentage": _vm.summary.deliveryRate,
      "show-text": false
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('i', {
    staticClass: "icon icon-2"
  }), _vm._v(" "), _c('p', {
    staticClass: "c9 f12"
  }, [_vm._v("满意度")]), _vm._v(" "), _c('p', {
    staticClass: "bold f16",
    staticStyle: {
      "padding-bottom": "4px"
    }
  }, [_vm._v(_vm._s(_vm.summary.satisfactionRate || 0) + "%")]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "percentage": _vm.summary.satisfactionRate,
      "show-text": false
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('i', {
    staticClass: "icon icon-3"
  }), _vm._v(" "), _c('p', {
    staticClass: "c9 f12"
  }, [_vm._v("下单率")]), _vm._v(" "), _c('p', {
    staticClass: "bold f16",
    staticStyle: {
      "padding-bottom": "4px"
    }
  }, [_vm._v(_vm._s(_vm.summary.orderRate || 0) + "%")]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "percentage": _vm.summary.orderRate,
      "show-text": false
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mb20 row-2",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("\n                            销售数据\n                            "), _c('el-date-picker', {
    staticClass: "fr",
    attrs: {
      "size": "mini",
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "placeholder": "请选择日期"
    },
    on: {
      "change": function($event) {
        return _vm.getSalesSummary()
      }
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "230px",
      "margin-top": "30px"
    }
  }, [_c('IEcharts', {
    attrs: {
      "option": _vm.option2
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("下单用户男女比例")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "250px",
      "margin-top": "10px"
    }
  }, [(this.summary.femaleRate != 100) ? _c('IEcharts', {
    attrs: {
      "option": _vm.option1
    }
  }) : _vm._e(), _vm._v(" "), (this.summary.femaleRate == 100) ? _c('p', {
    staticStyle: {
      "color": "#5e7382",
      "line-height": "250px",
      "text-align": "center"
    }
  }, [_vm._v("暂无数据")]) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row-2",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("营业收入")]), _vm._v(" "), _c('el-table', {
    staticClass: "mt10",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.summary.companyList,
      "height": "230",
      "border": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "公司",
      "show-overflow-tooltip": true,
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "营业额",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rate",
      "label": "占比"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.rate ? scope.row.rate : 0
          }
        })]
      }
    }], null, false, 728316541)
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.type != 1) ? _c('div', [_c('el-row', [_c('blockquote', {
    staticClass: "elem-quote"
  }, [_c('p', [_vm._v("郑重提示：您可操作的权限如下,请严格按照规定操作")])])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bb79404"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/dashboard/index.vue
// module id = 854
// module chunks = 0